'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');

// this return a list of days from 01 - 31
var dateList = tslib_es6.__spreadArrays(new Array(31)).map(function (_, index) {
    var paddedDay = String("" + ("0" + (index + 1))).slice(-2);
    return {
        label: paddedDay,
        value: paddedDay,
    };
});
var getYearList = function (person) {
    if (person === void 0) { person = 'adult'; }
    var adultYear = new Date().getFullYear() - 17;
    var yearByPerson = {
        'child': function () { return yearList.filter(function (d) { return d.value >= adultYear; }); },
        'adult': function () { return yearList.filter(function (d) { return d.value <= adultYear; }); },
    };
    return yearByPerson[person]();
};
var normalizeYearValues = function (additional) { return ({
    label: new Date().getFullYear() + additional,
    value: new Date().getFullYear() + additional,
}); };
var yearList = tslib_es6.__spreadArrays(new Array(80)).map(function (_, index) { return normalizeYearValues(-index); });
var monthList = [
    { label: 'Januari', value: '01' },
    { label: 'Februari', value: '02' },
    { label: 'Maret', value: '03' },
    { label: 'April', value: '04' },
    { label: 'Mei', value: '05' },
    { label: 'Juni', value: '06' },
    { label: 'Juli', value: '07' },
    { label: 'Agustus', value: '08' },
    { label: 'September', value: '09' },
    { label: 'Oktober', value: '10' },
    { label: 'November', value: '11' },
    { label: 'Desember', value: '12' },
];

exports.dateList = dateList;
exports.getYearList = getYearList;
exports.monthList = monthList;
exports.yearList = yearList;
//# sourceMappingURL=dates.js.map
